import { authenticatedRequest } from 'utils/api';
import basicFlow, { genericErrorHandler } from './asyncHandler';
import { put, select, takeLatest, takeEvery } from 'redux-saga/effects';
import * as actions from 'reducers/logsIntegracao.reducer';

const getEstadoLogs = (state) => state.logsIntegracao;

const sanitizarFiltros = (filtros) => {
  const payload = {};
  if (filtros.dataInicioFrom) payload.dataInicioFrom = filtros.dataInicioFrom;
  if (filtros.dataInicioTo) payload.dataInicioTo = filtros.dataInicioTo;
  if (filtros.flagSuccesso !== null && filtros.flagSuccesso !== undefined) {
    payload.flagSuccesso = filtros.flagSuccesso;
  }
  if (Array.isArray(filtros.codigoFluxo) && filtros.codigoFluxo.length > 0) {
    payload.codigoFluxo = filtros.codigoFluxo;
  }
  if (Array.isArray(filtros.tipoEvento) && filtros.tipoEvento.length > 0) {
    payload.tipoEvento = filtros.tipoEvento;
  }
  return payload;
};

const buildSearchBody = (estado) => ({
  filters: {
    idSimulacao: estado.idSimulacao,
    ...sanitizarFiltros(estado.filtros)
  },
  sort: estado.sort,
  page: estado.lista.page,
  pageSize: estado.lista.pageSize
});

const listarApi = (body) =>
  authenticatedRequest({
    url: '/log-auditoria/search',
    method: 'post',
    body
  });

const detalheApi = (id) =>
  authenticatedRequest({
    url: `/log-auditoria/show/${encodeURIComponent(id)}`,
    method: 'get'
  });

const listar = basicFlow({
  actionGenerator: actions.listarRequest,
  actionSuccess: actions.listarSuccess,
  actionFailure: actions.listarFailure,
  api: listarApi,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

const detalhe = basicFlow({
  actionGenerator: actions.detalheRequest,
  actionSuccess: actions.detalheSuccess,
  actionFailure: actions.detalheFailure,
  api: detalheApi,
  postFailure: function* ({ error }) {
    yield genericErrorHandler({ error });
  }
});

// Dispara busca a partir do estado atual (filtros/pagina/sort)
function* dispararBusca() {
  const estado = yield select(getEstadoLogs);
  if (!estado.modalAberto || !estado.idSimulacao) return;
  yield put(actions.listarRequest(buildSearchBody(estado)));
}

function* buscaTriggerWatcher() {
  yield takeLatest(
    [
      actions.abrirModal.type,
      actions.alterarFiltros.type,
      actions.alterarPaginacao.type,
      actions.alterarSort.type
    ],
    dispararBusca
  );
}

function* selecionarLogWatcher() {
  yield takeEvery(actions.selecionarLog.type, function* (action) {
    if (action.payload) {
      yield put(actions.detalheRequest(action.payload));
    }
  });
}

export const sagas = [
  listar.watcher(),
  detalhe.watcher(),
  buscaTriggerWatcher(),
  selecionarLogWatcher()
];
